export default __webpack_public_path__ + "static/media/main_sign.f8be978e.png";